/** Normalize phone for storage / duplicate check — strip spaces */
export function normalizeCampPhone(phone: string): string {
  return phone.replace(/\s+/g, "").trim();
}
